module.exports = __webpack_public_path__ + "static/media/booking3.dc9f3fb6.jpg";